import React from "react";
import { Card, Skeleton, Space } from "antd";

const ResumePreviewSkeleton = ({ style = {} }) => {
  return (
    <Card
      style={{
        width: "100%",
        maxWidth: "850px",
        margin: "0 auto",
        minHeight: "1100px",
        padding: "40px",
        backgroundColor: "#fff",
        ...style,
      }}
      bodyStyle={{ padding: "0" }}
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {/* Header Section - Name and Contact */}
        <div style={{ textAlign: "center", paddingBottom: "20px", borderBottom: "2px solid #f0f0f0" }}>
          <Skeleton.Input active style={{ width: "300px", height: "36px", marginBottom: "12px" }} />
          <Skeleton.Input active style={{ width: "400px", height: "20px" }} />
        </div>

        {/* Professional Summary */}
        <div>
          <Skeleton.Input active style={{ width: "150px", height: "24px", marginBottom: "12px" }} />
          <Skeleton active paragraph={{ rows: 3 }} />
        </div>

        {/* Work Experience */}
        <div>
          <Skeleton.Input active style={{ width: "180px", height: "24px", marginBottom: "16px" }} />
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <Skeleton.Input active style={{ width: "250px", height: "20px" }} />
                <Skeleton.Input active style={{ width: "120px", height: "18px" }} />
              </div>
              <Skeleton.Input active style={{ width: "200px", height: "18px", marginBottom: "8px" }} />
              <Skeleton active paragraph={{ rows: 2 }} />
            </div>
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <Skeleton.Input active style={{ width: "250px", height: "20px" }} />
                <Skeleton.Input active style={{ width: "120px", height: "18px" }} />
              </div>
              <Skeleton.Input active style={{ width: "200px", height: "18px", marginBottom: "8px" }} />
              <Skeleton active paragraph={{ rows: 2 }} />
            </div>
          </Space>
        </div>

        {/* Education */}
        <div>
          <Skeleton.Input active style={{ width: "120px", height: "24px", marginBottom: "16px" }} />
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <Skeleton.Input active style={{ width: "300px", height: "20px" }} />
              <Skeleton.Input active style={{ width: "100px", height: "18px" }} />
            </div>
            <Skeleton.Input active style={{ width: "250px", height: "18px" }} />
          </div>
        </div>

        {/* Skills */}
        <div>
          <Skeleton.Input active style={{ width: "80px", height: "24px", marginBottom: "12px" }} />
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => (
              <Skeleton.Button key={index} active size="small" style={{ width: `${80 + Math.random() * 40}px` }} />
            ))}
          </div>
        </div>
      </Space>
    </Card>
  );
};

export default ResumePreviewSkeleton;
